import React, { useContext, useEffect, useState } from 'react';

import BdsSegment from '../../../../../shared/components/v3/BdsSegment/BdsSegment';
import { CompanyContext } from '../../../../../shared/context/company/companyContext';
import { TRANSLATIONS_CHALLENGES_MAIN } from '../../../../../shared/translations/challenges';

import './ChallengeFilters.scss';

interface IChallengeFilters {
  onFilterChange: (string: string) => void;
}

const ChallengeFilters = ({ onFilterChange }: IChallengeFilters) => {
  const [tabIndex, setTabIndex] = useState(0);

  const { company } = useContext(CompanyContext);

  const filters = [
    {
      label: TRANSLATIONS_CHALLENGES_MAIN.filter.tabs.all,
      value: 'all'
    },
    {
      label: TRANSLATIONS_CHALLENGES_MAIN.table.filter.active,
      value: 'active'
    },
    {
      label: TRANSLATIONS_CHALLENGES_MAIN.table.filter.finished,
      value: 'finished'
    }
  ];

  const onTabChange = (index: number) => {
    setTabIndex(index);
    onFilterChange(filters[index].value);
  };

  useEffect(() => {
    setTabIndex(0);
  }, [company]);

  return (
    <div className="challenges-tabs">
      <div className="tabs-filter">
        <BdsSegment items={filters.map((filter) => filter.label)} action={onTabChange} activeIndex={tabIndex} />
      </div>
    </div>
  );
};
export default ChallengeFilters;
